export type NativePlatform = 'android' | 'ios';

export interface AppVersions {
  android: number;
  ios: number;
}

export const isSupportedNativePlatform = (
  platform: string
): platform is NativePlatform => platform === 'android' || platform === 'ios';

const toPositiveBuildNumber = (value: unknown): number | null => {
  const buildNumber = typeof value === 'string' ? Number(value) : value;

  return typeof buildNumber === 'number' &&
    Number.isInteger(buildNumber) &&
    buildNumber > 0
    ? buildNumber
    : null;
};

export const getLatestBuild = (
  versions: AppVersions,
  platform: NativePlatform
): number => versions[platform];

export const isAppUpdateRequired = (
  currentBuild: unknown,
  latestBuild: unknown
): boolean => {
  const currentBuildNumber = toPositiveBuildNumber(currentBuild);
  const latestBuildNumber = toPositiveBuildNumber(latestBuild);

  return (
    currentBuildNumber !== null &&
    latestBuildNumber !== null &&
    currentBuildNumber < latestBuildNumber
  );
};
